import React from 'react';
import useThemeColor from '../../../hooks/useThemeColor';

const Pagination = ({
  totalRecords,
  pageSize,
  pageNumber,
  totalPages,
  setPageNumber,
  variant = 'default',
  className = '',
  showSummary = true,
  showPageControls = true,
}) => {
  const themeColor = useThemeColor();
  const isInline = variant === 'inline';
  const shouldShowPageControls = showPageControls && totalPages > 1;

  if (!showSummary && !shouldShowPageControls) {
    return null;
  }

  return (
    <div
      className={`${
        isInline
          ? 'd-flex flex-wrap align-items-center gap-2 gap-md-3 mb-0'
          : 'd-md-flex mt-3 align-items-center'
      } ${className}`.trim()}
    >
      {showSummary && (
        <div
          className={
            isInline
              ? 'text-muted small mb-0'
              : 'me-md-auto text-md-left text-center mb-2 mb-md-0'
          }
        >
          Showing {totalRecords === 0 ? 0 : (pageNumber - 1) * pageSize + 1} to{' '}
          {Math.min(pageNumber * pageSize, totalRecords)} of {totalRecords} entries
        </div>
      )}
      {shouldShowPageControls && (
        <ul
          className={`pagination mb-0 ${isInline ? 'flex-wrap' : 'justify-content-center'}`}
        >
          <li className={`page-item ${pageNumber === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => setPageNumber(pageNumber - 1)}
              style={{
                backgroundColor: pageNumber === 1 ? '#f8f9fa' : 'transparent',
                color: pageNumber === 1 ? '#6c757d' : themeColor,
                borderColor: themeColor,
              }}
            >
              Previous
            </button>
          </li>
          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${index + 1 === pageNumber ? 'active' : ''}`}
            >
              <button
                className="page-link"
                onClick={() => setPageNumber(index + 1)}
                style={{
                  backgroundColor:
                    index + 1 === pageNumber ? themeColor : 'transparent',
                  color: index + 1 === pageNumber ? 'white' : themeColor,
                  borderColor: themeColor,
                }}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li className={`page-item ${pageNumber === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => setPageNumber(pageNumber + 1)}
              style={{
                backgroundColor:
                  pageNumber === totalPages ? '#f8f9fa' : 'transparent',
                color: pageNumber === totalPages ? '#6c757d' : themeColor,
                borderColor: themeColor,
              }}
            >
              Next
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Pagination;

